import React from 'react'
import { Button } from '@mui/material'

const AdxHeaderButton = ({
  children,
  icon,
  onClick,
  variant = 'contained', // 'contained' or 'outlined'
  color = 'primary', // 'primary' or 'secondary'
  ...props
}) => {
  const styles = {
    primary: {
      bgcolor: '#F3BF3A',
      color: 'white',
      '&:hover': {
        bgcolor: '#d9a832',
      },
    },
    secondary: {
      bgcolor: '#FDF6E2',
      color: 'text.primary',
      border: '1px solid #F3BF3A',
      '&:hover': {
        bgcolor: '#fcefc4',
      },
    },
    primaryTask: {
      bgcolor: '#f3bf3a',
      color: '#262626',
      '&:hover': {
        bgcolor: '#d09a01',
        color: '#262626'
      }
    },
    secondaryTask: {
      bgcolor: 'transparent',
      color: '#262626',
      border: '1px solid #f3bf3a',
      '&:hover': {
        bgcolor: '#fdf6e2',
        color: '#262626',
        border: '1px solid #f3bf3a'
      }
    }
  }

  return (
    <Button
      variant={variant}
      startIcon={icon}
      onClick={onClick}
      sx={{
        ...styles[color],
        textTransform: 'none',
        borderRadius: 100,
        px: 3,
        py: 1,
        fontWeight: 500,
        boxShadow: 'none', // Remove default shadow
        '&:hover': {
          ...styles[color]['&:hover'],
          boxShadow: 'none', // Remove shadow on hover too
        },
        '&:active': {
          boxShadow: 'none', // Remove shadow on click
        },
        ...props.sx,
      }}
      {...props}
    >
      {children}
    </Button>
  )
}

export default AdxHeaderButton